import axios from '@/libs/api.request'

// 获取系统状态
export const getSystemStatus = () => {
  return axios.request({
    url: 'monitor/system-status',
    method: 'get'
  })
}

// 获取API性能统计
export const getApiPerformance = (params) => {
  return axios.request({
    url: 'monitor/api-performance',
    method: 'post',
    data: params
  })
}

// 获取数据库状态
export const getDatabaseStatus = () => {
  return axios.request({
    url: 'monitor/database-status',
    method: 'get'
  })
}

// 获取业务监控数据
export const getBusinessMonitor = () => {
  return axios.request({
    url: 'monitor/business',
    method: 'get'
  })
}

// 获取告警规则列表
export const getAlertRules = () => {
  return axios.request({
    url: 'monitor/alert-rules',
    method: 'get'
  })
}

// 保存告警规则
export const saveAlertRule = (data) => {
  return axios.request({
    url: 'monitor/alert-rules',
    method: 'post',
    data
  })
}

// 更新告警规则
export const updateAlertRule = (id, data) => {
  return axios.request({
    url: `monitor/alert-rules/${id}`,
    method: 'put',
    data
  })
}

// 删除告警规则
export const deleteAlertRule = (id) => {
  return axios.request({
    url: `monitor/alert-rules/${id}`,
    method: 'delete'
  })
}

// 获取告警历史
export const getAlertHistory = (params) => {
  return axios.request({
    url: 'monitor/alert-history',
    method: 'post',
    data: params
  })
}

// 获取实时监控数据
export const getRealtimeData = () => {
  return axios.request({
    url: 'monitor/realtime',
    method: 'get'
  })
}

